import { Observable } from 'rxjs';
import { DataSourceResponse, FormMedInspectionModel, RegisterPatient } from '../../models';
import { Injectable } from '@angular/core';
import { ApiService } from '@meddatacore/common';
import { HttpParamsEncoder } from '../../tools';
import { HttpParams } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class RegisterPatientService extends ApiService {
    endPoint = '/api/registerPatients';
    create(model: RegisterPatient) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}`, model);
    }
    update(id: string, model: RegisterPatient) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}`, model);
    }
    getByAppointmentId(appointmentId: string) {
        return this.http.get<RegisterPatient>(`${this.clinicsBaseURL}${this.endPoint}/byappontment/${appointmentId}`);
    }
    getById(id: string) {
        return this.http.get<RegisterPatient>(`${this.clinicsBaseURL}${this.endPoint}/${id}`);
    }
    getByCaseHistoryId(caseHistoryId: string) {
        return this.http.get<RegisterPatient>(`${this.clinicsBaseURL}${this.endPoint}/case-history/${caseHistoryId}`);
    }
    getEmployeePostion(id: string, positionId: string) {
        return this.http.get<RegisterPatient>(`${this.clinicsBaseURL}${this.endPoint}/${id}/ChangeTreatEmployee/${positionId}`);
    }
    getForPerson(hasReciept?: boolean): Observable<RegisterPatient[]> {
        let params = new HttpParams();

        if (hasReciept != null) {
            params = params.append('hasReciept', hasReciept);
        }
        return this.http.get<RegisterPatient[]>(`${this.clinicsBaseURL}${this.endPoint}/for-person`, { params });
    }

    getList(queryParams: any): Observable<DataSourceResponse<RegisterPatient>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}`, { params });
    }
    getListWithAppointmentDrugs(queryParams: any): Observable<DataSourceResponse<any>> {
        const params = new HttpParamsEncoder().encode(queryParams);
        return this.http.get<any>(`${this.clinicsBaseURL}${this.endPoint}/GetWithAppointmentDrugs`, { params });
    }
    saveFormMedInspection(id: string, model: FormMedInspectionModel) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}/FormMedInspection`, model);
    }
    updateSignalInformation(id: string, model: any) {
        return this.http.put(`${this.clinicsBaseURL}${this.endPoint}/${id}/signalInformation`, model);
    }
    createInvoice(id: string) {
        return this.http.post(`${this.clinicsBaseURL}${this.endPoint}/${id}/CreateInvoice`, {});
    }
    asPdf(id: string, medRecordType: any) {
        
        return this.http.get(`${this.clinicsBaseURL}${this.endPoint}/${id}/aspdf/${medRecordType}`, { responseType: 'blob' as 'json' });
    }
}
